import Indexable from '../../shared/types/Indexable.types';

export type Row = any[] | Indexable;
export type Alignment = ('left' | 'right' | '')[];
export type HeaderDirection = { index: number; state: 'asc' | 'desc' };

export enum StripePattern {
  Odd = 'odd',
  Even = 'even',
}

export enum Layout {
  Row = 'row',
  Column = 'column'
};

export default interface TableProps {
  headers?: Row;
  // eslint-disable-next-line prettier/prettier
  layout?: `${Layout}`;
  columnAlignment?: Alignment;
  caption?: string;
  hideCaption?: boolean;
  data: Row[];
  paginationMessage?: string;
  resultsPerPage?: number;
  columnKeys?: string[];
  headerOnClick?: (columnIndex: number) => void;
  headerDirection?: HeaderDirection;
  truncateOver?: number;
  // eslint-disable-next-line prettier/prettier
  striped?: `${StripePattern}`;
  style?: 'standard' | 'colored-header';
  className?: string;
  dataCy?: string;
}
